export default __webpack_public_path__ + "static/media/proofs_reg_image.a43dcbef.png";